var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3079E6"
    },
    d: "M16.414,31.414l16.172,16.173c0.905,0.906,2.134,1.414,3.414,1.414h0 c1.281,0,2.509-0.509,3.414-1.414L45,42.001l-8-8l-4,3.998L25.999,31L30,27l-8-8l-5.586,5.586C15.509,25.491,15,26.719,15,28v0 C15,29.281,15.509,30.509,16.414,31.414z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.982,
    y: 18.593,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -9.8982 24.6035)",
    style: {
      fill: "#2763BB"
    },
    width: 3.536,
    height: 11.313
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.983,
    y: 33.594,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.112 39.6041)",
    style: {
      fill: "#2763BB"
    },
    width: 3.535,
    height: 11.314
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.545,14.433l-1.646,1.135C59.236,20.412,61,26.094,61,32c0,15.99-13.009,29-29,29c-7.637,0-14.847-2.944-20.3-8.29 l-1.4,1.428C16.129,59.853,23.836,63,32,63c17.093,0,31-13.906,31-31C63,25.687,61.114,19.612,57.545,14.433z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,3c7.438,0,14.622,2.899,19.99,8H49v2h5c0.552,0,1-0.447,1-1V7h-2v2.213C47.304,3.972,39.783,1,32,1 C14.907,1,1,14.906,1,32c0,6.771,2.144,13.204,6.201,18.604l1.599-1.201C5.005,44.353,3,38.335,3,32C3,16.01,16.009,3,32,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.254,39.512c-0.206-0.595-0.389-1.207-0.545-1.82l-1.938,0.494c0.17,0.666,0.37,1.332,0.593,1.979L10.254,39.512z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.318,35.834c-0.104-0.619-0.184-1.254-0.237-1.886l-1.993,0.168c0.058,0.687,0.145,1.376,0.257,2.048L9.318,35.834z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.686,26.402l-1.94-0.484c-0.166,0.664-0.307,1.345-0.417,2.023l1.974,0.322C9.403,27.64,9.533,27.014,9.686,26.402z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.077,22.01c-0.274,0.626-0.526,1.275-0.748,1.929l1.894,0.645c0.204-0.601,0.435-1.196,0.687-1.771L9.077,22.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.233,16.692l1.58,1.227c0.387-0.499,0.799-0.987,1.226-1.453l-1.475-1.352C13.1,15.621,12.652,16.151,12.233,16.692z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.294,47.387l1.576-1.232c-0.392-0.501-0.764-1.021-1.107-1.543l-1.673,1.096 C11.463,46.276,11.868,46.841,12.294,47.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.826,13.885l-1.234-1.574c-0.542,0.426-1.071,0.877-1.571,1.34l1.359,1.467C16.839,14.691,17.326,14.276,17.826,13.885 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.71,19.467l-1.676-1.092c-0.373,0.573-0.728,1.171-1.055,1.776l1.761,0.949C12.041,20.543,12.368,19.993,12.71,19.467z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,32v0.052L9,32c0-0.614,0.024-1.237,0.073-1.85l-1.994-0.158C7.027,30.657,7,31.333,7,32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.916,53.983c0.6-0.326,1.195-0.683,1.771-1.059l-1.096-1.674c-0.53,0.348-1.079,0.676-1.631,0.977L43.916,53.983z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.447,48.945c-0.467-0.429-0.919-0.88-1.346-1.342l-1.47,1.355c0.463,0.503,0.955,0.993,1.462,1.459L16.447,48.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.139,55.645c0.645-0.222,1.291-0.475,1.922-0.751l-0.805-1.832c-0.581,0.256-1.176,0.488-1.768,0.692L40.139,55.645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.14,56.659c0.681-0.114,1.36-0.257,2.019-0.424l-0.49-1.939c-0.607,0.154-1.233,0.285-1.861,0.391L36.14,56.659z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.948,41.279l-1.83,0.807c0.275,0.624,0.582,1.247,0.911,1.853l1.757-0.955C11.483,42.426,11.201,41.853,10.948,41.279z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.893,56.248l0.488-1.939c-0.617-0.155-1.23-0.337-1.821-0.539l-0.647,1.893C24.556,55.882,25.222,56.079,25.893,56.248 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.027,57c0.683-0.001,1.376-0.03,2.062-0.086l-0.164-1.994c-0.631,0.053-1.271,0.079-1.9,0.08L32.027,57z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.353,52.949l1.094-1.674c-0.534-0.35-1.055-0.721-1.546-1.104l-1.229,1.578C17.206,52.166,17.772,52.57,18.353,52.949z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.986,54.913l0.801-1.832c-0.583-0.255-1.156-0.535-1.706-0.833l-0.954,1.758 C20.727,54.331,21.352,54.637,21.986,54.913z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.965,56.919l0.161-1.994c-0.634-0.051-1.269-0.129-1.886-0.229l-0.324,1.973 C28.586,56.778,29.276,56.863,29.965,56.919z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.516,15.021c0.467,0.427,0.921,0.878,1.348,1.339l1.467-1.359c-0.464-0.501-0.957-0.991-1.465-1.456L47.516,15.021z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.859,21.865c-0.277-0.625-0.585-1.248-0.915-1.852l-1.755,0.961c0.304,0.555,0.587,1.127,0.842,1.701L54.859,21.865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.964,9.065l-0.798,1.834c0.58,0.252,1.155,0.531,1.709,0.83l0.948-1.762C43.22,9.644,42.595,9.34,41.964,9.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.94,50.387l-1.356-1.471c-0.461,0.426-0.948,0.84-1.449,1.23l1.23,1.576C47.91,51.298,48.439,50.849,48.94,50.387z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.601,11.021l-1.089,1.678c0.532,0.346,1.053,0.716,1.549,1.1l1.226-1.58C46.747,11.799,46.18,11.396,45.601,11.021z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1,17.806c0.392,0.5,0.766,1.019,1.11,1.541l1.67-1.1c-0.375-0.569-0.781-1.134-1.207-1.676L50.1,17.806z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.734,47.349l-1.578-1.229c-0.387,0.497-0.8,0.985-1.229,1.451l1.472,1.354C50.865,48.419,51.314,47.889,51.734,47.349z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.664,36.111l-1.974-0.326c-0.103,0.624-0.233,1.249-0.387,1.858l1.938,0.49C56.41,37.471,56.552,36.79,56.664,36.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.654,40.113l-1.892-0.648c-0.205,0.597-0.438,1.192-0.691,1.771l1.831,0.805 C55.178,41.411,55.431,40.763,55.654,40.113z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.995,43.895l-1.759-0.953c-0.3,0.555-0.628,1.104-0.974,1.633l1.674,1.094C53.312,45.094,53.668,44.497,53.995,43.895z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.729,24.442c0.208,0.597,0.393,1.208,0.548,1.817l1.938-0.496c-0.17-0.663-0.371-1.329-0.597-1.979L53.729,24.442z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.92,7c-0.688,0.002-1.381,0.032-2.063,0.091l0.17,1.992C30.654,9.03,31.293,9.002,31.926,9L31.92,7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.054,7.738L37.572,9.68c0.611,0.151,1.225,0.332,1.822,0.535l0.644-1.895C39.387,8.1,38.72,7.904,38.054,7.738z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.81,7.35c-0.674,0.113-1.354,0.258-2.021,0.429l0.496,1.938c0.613-0.157,1.238-0.289,1.857-0.394L27.81,7.35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.464,10.264l-0.653-1.891c-0.648,0.225-1.294,0.479-1.922,0.757l0.81,1.828C23.275,10.703,23.87,10.469,24.464,10.264z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.037,10.042c-0.6,0.328-1.195,0.686-1.769,1.062l1.099,1.672c0.528-0.348,1.076-0.677,1.629-0.979L20.037,10.042z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,31.986l0-0.09h-2L55,32c0,0.631-0.026,1.27-0.077,1.899l1.993,0.162C56.972,33.379,57,32.685,57,31.986z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.674,28.118c0.105,0.617,0.186,1.251,0.241,1.885l1.992-0.174c-0.06-0.687-0.147-1.375-0.262-2.047L54.674,28.118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.032,7.323c-0.676-0.109-1.366-0.192-2.051-0.246l-0.155,1.994c0.63,0.049,1.264,0.125,1.885,0.227L36.032,7.323z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.707,41.294l-8-8c-0.391-0.391-1.023-0.391-1.414,0L33,36.585L27.414,31l3.293-3.293C30.895,27.52,31,27.266,31,27 s-0.105-0.52-0.293-0.707l-8-8c-0.391-0.391-1.023-0.391-1.414,0l-5.586,5.586C14.622,24.964,14,26.466,14,28 s0.622,3.036,1.707,4.121l16.172,16.173c1.101,1.101,2.564,1.707,4.121,1.707c1.558,0,3.022-0.606,4.121-1.707l5.586-5.586 C46.098,42.317,46.098,41.685,45.707,41.294z M22,20.414L28.586,27L27.5,28.086L20.914,21.5L22,20.414z M38.707,46.88 c-1.444,1.445-3.967,1.445-5.414,0L17.121,30.707C16.409,29.994,16,29.008,16,28s0.409-1.994,1.121-2.707l2.379-2.379l6.586,6.586 l-0.794,0.793c-0.188,0.188-0.293,0.441-0.293,0.707s0.105,0.52,0.293,0.707l7.001,6.999c0.391,0.391,1.023,0.391,1.414,0 l0.793-0.792l6.587,6.587L38.707,46.88z M42.5,43.086L35.914,36.5L37,35.415l6.586,6.586L42.5,43.086z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,24v2c1.654,0,3,1.346,3,3h2C40,26.243,37.757,24,35,24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44,29c0-4.963-4.038-9-9-9v2c3.86,0,7,3.141,7,7H44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,29c0-7.168-5.832-13-13-13v2c6.065,0,11,4.935,11,11H48z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.6dfe216e8c078757560ea6e8185ff04f.svg";
export { ForwardRef as ReactComponent };